import { render, staticRenderFns } from "./privacyIOS.vue?vue&type=template&id=579ea808&scoped=true&"
import script from "./privacyIOS.vue?vue&type=script&lang=js&"
export * from "./privacyIOS.vue?vue&type=script&lang=js&"
import style0 from "./privacyIOS.vue?vue&type=style&index=0&id=579ea808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579ea808",
  null
  
)

export default component.exports